<template>
  <Flex align="center">
    <BaseHeading
      center
      size="xl"
    >
      {{ value }}
    </BaseHeading>
    <BaseText>{{ $t(`marketing.insights.stats.${text}`) }}</BaseText>
  </Flex>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    value: {
      type: Number,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
});
</script>
